/* eslint-disable react/display-name */
import React from 'react';
import { Switch } from 'react-router-dom';
import { ADMIN_ROUTES } from '../constants/router';

import TableDocument from '../container/Document/TableDocument';
import NewDocument from '../container/Document/NewDocument';
import EditDocument from '../container/Document/EditDocument';
import DetailDocument from '../container/Document/DetailDocument';

import AuthRoute from './AuthRoute';

const routes = [
  {
    path: ADMIN_ROUTES.ACTIVE_DOCUMENTS,
    component: () => <TableDocument />,
    exact: true,
    meta: {
      action: 'information_all_view',
      subject: 'information'
    }
  },
  {
    path: `${ADMIN_ROUTES.ACTIVE_DOCUMENTS}/new`,
    component: () => <NewDocument />,
    exact: true
  },
  {
    path: `${ADMIN_ROUTES.ACTIVE_DOCUMENTS}/edit/:id`,
    component: () => <EditDocument />,
    exact: true
  },
  {
    path: `${ADMIN_ROUTES.ACTIVE_DOCUMENTS}/detail/:id`,
    component: () => <DetailDocument />,
    exact: true
  }
];

const StudentRoutes = () => {
  if (typeof window !== 'undefined') {
    return (
      <>
        <Switch>
          {routes.map((route) => (
            <AuthRoute key={route.path} {...route} />
          ))}
        </Switch>
      </>
    );
  }
  return '';
};

export default StudentRoutes;
